import { useState, useCallback, useEffect } from 'react';
import { Box, Checkbox, FormControlLabel, makeStyles } from '@material-ui/core';
import { baseCssOccupieddischarge } from '../../PopWindows/baseCss';
import { bedStatusAPI } from '../../../../../apis';
import { i18n } from '../../../../../language';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '80%',
    flex: '1',
    display: 'flex',
    margin: '0 3.437rem',
    background: '#fff',
    padding: '1.875rem',
    borderRadius: '0 0.93rem 0.93rem 0.93rem',
  },
  checkBox: {
    width: '1.5rem',
    height: '1.5rem',
    '& .MuiTypography-root': {
      fontSize: '1rem',
      fontFamily: 'NotoSans-Medium',
      fontWeight: '500',
    },
  },
}));
export default function SettingTransferIn() {
  const classes = useStyles();
  const baseClasses = baseCssOccupieddischarge();
  const [checkBox, setCheckBox] = useState(false);
  const transferEnableDetail = useCallback(async () => {
    try {
      const { result } = await bedStatusAPI.getTransferEnabledetail();
      setCheckBox(result.enableYn);
    } catch (error) {}
  }, []);
  const transferEnableUpdate = useCallback(async (checked) => {
    try {
      await bedStatusAPI.postTransferEnableUpdate({ enableYn: checked });
    } catch (error) {}
  }, []);
  const onChangeHandle = (event) => {
    setCheckBox(event.target.checked);
    let enableYn;
    if (event.target.checked) {
      enableYn = 1;
    } else {
      enableYn = 0;
    }
    (async () => {
      await transferEnableUpdate(enableYn);
    })();
  };
  useEffect(() => {
    (async () => {
      await transferEnableDetail();
    })();
  }, [transferEnableDetail]);
  return (
    <div className={classes.root}>
      <Box>
        <FormControlLabel
          id="bed_occupieddischarge_home_leave"
          control={<Checkbox />}
          label={i18n.t('BEDSTATUS_ENABLE_REVCEIVING_TRANSFER_IN')}
          className={baseClasses.checkBox}
          checked={Boolean(checkBox)} // 3.
          onChange={onChangeHandle}
        />
      </Box>
    </div>
  );
}
